export class ActivityLogDetails {
  id: number;
  transaction: string;
  account: string;
  status: number;
  amount: number;
  currency: string;
  dateUpdated: string;

  constructor(
    id: number,
    transaction: string,
    account: string,
    status: number,
    amount: number,
    currency: string,
    dateUpdated: string,
  ) {
    this.id = id;
    this.transaction = transaction;
    this.account = account;
    this.status = status;
    this.amount = amount;
    this.currency = currency;
    this.dateUpdated = dateUpdated;
  }
}
